import request from '@/utils/request';
import type { Status, PaginatedResponse } from '@/types/common';
import type {
  Permission,
  PermissionQueryParams,
  CreatePermissionData,
  UpdatePermissionData
} from '@/types/permission';

export const permissionService = {
  // 获取权限列表
  getPermissions: async (params: PermissionQueryParams): Promise<PaginatedResponse<Permission>> => {
    const response = await request.get<PaginatedResponse<Permission>>('/api/admin/permissions', { params });
    return response;
  },

  // 获取权限详情
  getPermissionById: async (id: number): Promise<Permission> => {
    const response = await request.get(`/api/admin/permissions/${id}`);
    return response;
  },

  // 创建权限
  createPermission: async (data: CreatePermissionData): Promise<Permission> => {
    const response = await request.post('/api/admin/permissions', data);
    return response;
  },

  // 更新权限
  updatePermission: async (id: number, data: UpdatePermissionData): Promise<Permission> => {
    const response = await request.put(`/api/admin/permissions/${id}`, data);
    return response;
  },

  // 删除权限
  deletePermission: async (id: number): Promise<void> => {
    await request.delete(`/api/admin/permissions/${id}`);
  },

  // 更新权限状态
  updatePermissionStatus: async (id: number, status: Status): Promise<void> => {
    await request.patch(`/api/admin/permissions/${id}/status`, { status });
  },

  // 更新权限排序
  updatePermissionSort: async (id: number, sort: number): Promise<void> => {
    await request.patch(`/api/admin/permissions/${id}/sort`, { sort });
  },

  // 获取权限树
  getPermissionTree: async (): Promise<Permission[]> => {
    const response = await request.get<Permission[]>('/api/admin/permissions/tree');
    return response;
  },
};
